import axios from 'axios';
let baseURL = 'https://test-api.lvshuhualv.com/';

// if (process.env.NODE_ENV !== 'development') {
//     baseURL = 'http://218.66.91.50:7991/lv';
// }

let isDev = process.env.NODE_ENV === 'development',
    ajax = axios.create({
        baseURL,
        withCredentials: true
    });

ajax.interceptors.request.use(function (config) {
    config.headers = {
        Authorization: localStorage.getItem('access_token')
    };
    return config;
});
ajax.interceptors.response.use(
    function (res) {
        return res.data;
    },
    function (error) {
        return Promise.reject('网络错误');
    }
);

export default ajax;
